angular
  .module 'filters'
  .filter 'currencyWithoutFraction', ($filter) ->
    (amount, symbol) ->
      negative = amount < 0
      val = $filter('currency')(Math.abs(amount), symbol).slice(0, -3)
      if negative then  "-#{val}" else val
